import { useNavigate } from 'react-router-dom';
import { apiClient } from '../api';
import { CapacityFullPage } from './CapacityFullPage';

export function WaitingPage() {
  const navigate = useNavigate();

  const handleRetry = async () => {
    try {
      const capacity = await apiClient.checkCapacity();
      if (!capacity.hasCapacity) {
        return;
      }
      navigate('/connect');
    } catch (_error) {
      return;
    }
  };

  return <CapacityFullPage onRetry={handleRetry} />;
}
